import React from 'react';
import { Tag } from 'antd';

export const sourceBadge = (sourceType) => {
    if (sourceType === 'direct') {
        return <Tag color="purple">Direct</Tag>;
    }
    return <Tag color="blue">Purchase</Tag>;
};

export const groupStatusBadge = (status) => {
    switch (status) {
        case 'active':
            return <Tag color="green">Active</Tag>;
        case 'awaiting-payment':
            return <Tag color="geekblue">Awaiting payment</Tag>;
        case 'activating':
            return <Tag color="processing">Activating</Tag>;
        case 'partner-failed':
            return <Tag color="red">Partner failed</Tag>;
        case 'partial-failed':
            return <Tag color="volcano">Partial failed</Tag>;
        case 'pending':
            return <Tag color="gold">Pending</Tag>;
        case 'refunded':
            return <Tag color="orange">Refunded</Tag>;
        case 'cancelled':
            return <Tag color="default">Cancelled</Tag>;
        default:
            return <Tag>{status || '—'}</Tag>;
    }
};

export const statusBadge = (status) => {
    switch (status) {
        case 'active':
            return <Tag color="green">Active</Tag>;
        case 'pending':
            return <Tag color="gold">Pending</Tag>;
        case 'refunded':
            return <Tag color="orange">Refunded</Tag>;
        case 'cancelled':
            return <Tag color="default">Cancelled</Tag>;
        case 'expired':
            return <Tag color="default">Expired</Tag>;
        default:
            return <Tag>{status || '—'}</Tag>;
    }
};

export const partnerCallStatusBadge = (status) => {
    switch (status) {
        case 'success':
            return <Tag color="green">Success</Tag>;
        case 'failed':
            return <Tag color="red">Failed</Tag>;
        case 'pending':
            return <Tag color="gold">Pending</Tag>;
        default:
            return <Tag>{status || '—'}</Tag>;
    }
};

export const healthBadge = (state) => {
    switch (state) {
        case 'healthy':
            return <Tag color="green">Healthy</Tag>;
        case 'failed_partner':
            return <Tag color="red">Partner failed</Tag>;
        case 'refund_stuck':
            return <Tag color="volcano">Refund stuck</Tag>;
        case 'onboarding_stuck':
            return <Tag color="orange">Onboarding stuck</Tag>;
        case 'backfill_stuck':
            return <Tag color="gold">Backfill stuck</Tag>;
        case 'state_drift':
            return <Tag color="magenta">State drift</Tag>;
        default:
            return <Tag>{state || '—'}</Tag>;
    }
};

const FAILURE_CODE_LABELS = {
    F1: 'PG charge failed',
    F2: 'Wallet deduct failed mid-flow',
    F3: 'Partner refused (4xx)',
    F4: 'Partner retries exhausted',
    F5: 'Refund: wallet credit step failed',
    F6: 'Refund: PG step failed',
    F7: 'Refund: status flip stuck',
    F8: 'DOPE onboarding call failed',
    F9: 'Kafka consumer choked',
    F10: 'dpu_id never backfilled on gym_enrollments',
    F11: 'dpu_id never backfilled on fitpass_auth',
    F12: 'getToken after register failed',
    F13: 'partner_success but status=pending',
    F14: "status='refunded' but money not returned",
    F15: 'admin-onboard published failed',
};

export const failureCodeLabel = (code) => FAILURE_CODE_LABELS[code] || code;
